/**
 * Regras do modal de criação rápida de cliente (D10) — separadas do componente
 * pra serem testáveis sem DOM.
 *
 * `segment` é OBRIGATÓRIO em `CreateCustomerRequest`; o cadastro completo
 * default para `'general'` e o atalho faz igual. O documento vai mascarado
 * mesmo: o Zod do backend normaliza com `digitsOnly` antes de validar tamanho.
 */
import type { CreateCustomerRequest } from '@troia-v3/types';

import { documentDigitsOnly, documentLabel } from '@/shared/utils/documentMask';

export interface QuickCustomerForm {
  name: string;
  type: 'PF' | 'PJ';
  document: string;
}

export interface QuickCustomerError {
  field: 'name' | 'document';
  message: string;
}

export function validateQuickCustomer(form: QuickCustomerForm): QuickCustomerError | null {
  if (form.name.trim().length < 2) {
    return { field: 'name', message: 'Informe o nome do cliente (mínimo 2 caracteres)' };
  }

  const digits = documentDigitsOnly(form.document);
  if (digits.length > 0) {
    const expected = form.type === 'PF' ? 11 : 14;
    if (digits.length !== expected) {
      return { field: 'document', message: `${documentLabel(form.type)} inválido — informe ${expected} dígitos` };
    }
  }

  return null;
}

export function buildQuickCustomerPayload(form: QuickCustomerForm): CreateCustomerRequest {
  const document = form.document.trim();
  return {
    name: form.name.trim(),
    type: form.type,
    segment: 'general',
    ...(document ? { document } : {}),
  };
}
